var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiRsTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8343_103704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 0H14V1C14 1.53043 13.7893 2.03914 13.4142 2.41421C13.0391 2.78929 12.5304 3 12 3C11.4696 3 10.9609 2.78929 10.5858 2.41421C10.2107 2.03914 10 1.53043 10 1V0H6C5.20435 0 4.44129 0.31607 3.87868 0.87868C3.31607 1.44129 3 2.20435 3 3V24H10V23C10 22.4696 10.2107 21.9609 10.5858 21.5858C10.9609 21.2107 11.4696 21 12 21C12.5304 21 13.0391 21.2107 13.4142 21.5858C13.7893 21.9609 14 22.4696 14 23V24H21V3C21 2.20435 20.6839 1.44129 20.1213 0.87868C19.5587 0.31607 18.7956 0 18 0V0ZM15.874 22C15.653 21.1405 15.1524 20.3789 14.4511 19.835C13.7498 19.2912 12.8875 18.9961 12 18.9961C11.1125 18.9961 10.2502 19.2912 9.5489 19.835C8.84756 20.3789 8.347 21.1405 8.126 22H5V17H8V15H5V3C5 2.73478 5.10536 2.48043 5.29289 2.29289C5.48043 2.10536 5.73478 2 6 2H8.126C8.347 2.85953 8.84756 3.62115 9.5489 4.16498C10.2502 4.7088 11.1125 5.00395 12 5.00395C12.8875 5.00395 13.7498 4.7088 14.4511 4.16498C15.1524 3.62115 15.653 2.85953 15.874 2H18C18.2652 2 18.5196 2.10536 18.7071 2.29289C18.8946 2.48043 19 2.73478 19 3V15H16V17H19V22H15.874Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9997 15H9.99976V17H13.9997V15Z",
    fill: "#1D1D1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8343_103704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRsTicket);
export default __webpack_public_path__ + "static/media/fi-rs-ticket.17e6a91888f50ab048f8e5a8f1ab6717.svg";
export { ForwardRef as ReactComponent };